import { Component } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

@Component({
    selector: 'tidy-upload-pros-onboarding',
    templateUrl: './upload-pros.component.html',
    styleUrls: ['./upload-pros.component.scss'],
    standalone: false
})

export class UploadProsOnboardingComponent {
  
  
  boundUploadPros = this.uploadPros.bind(this);

constructor(
    private onboardingProvider: OnboardingProvider,
    public windowService: WindowService
  ) {}

  openFilePicker() {
    //TODO
  }
  
  uploadPros() {
    //TODO
  }

} 

